export function toTitleCase(str: string): string {
  let strAr = str.split(' ');
  for (var i = 0; i < strAr.length; i += 1) {
    strAr[i] = strAr[i].charAt(0).toUpperCase() + strAr[i].substring(1).toLowerCase();
  }

  return strAr.join(' ');
}
